module.exports = __webpack_public_path__ + "img/OVAL METAL.2c9ac987.jpg";